import { pushEcommerceEvent } from '~/gtm/dataLayer';
import type { GA4PromotionItem } from '~/gtm/types';

/**
 * Push view_promotion event when promotions/banners become visible
 */
export function pushViewPromotion(promotions: GA4PromotionItem[]): void {
  if (promotions.length === 0) return;

  pushEcommerceEvent('view_promotion', {
    items: promotions,
  });
}

/**
 * Push select_promotion event when a promotion/banner is clicked
 */
export function pushSelectPromotion(promotion: GA4PromotionItem): void {
  pushEcommerceEvent('select_promotion', {
    items: [promotion],
  });
}

/**
 * Helper to create a promotion item from banner data
 */
export interface BannerData {
  title?: string;
  subtitle?: string;
  link?: string;
  desktopImage?: string;
  mobileImage?: string;
}

export function createPromotionItem(banner: BannerData, slotName: string, index: number): GA4PromotionItem {
  return {
    promotion_id: `${slotName}_${index}`,
    promotion_name: banner.title || `Banner ${index + 1}`,
    creative_name: banner.subtitle || banner.title || undefined,
    creative_slot: slotName,
    location_id: slotName,
    index,
  };
}
